import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffQuery = () => import('./staff/query')
const ViewStaffLog = () =>  import('./staff/log')

Vue.use(Router)

const router =
  [
    {
      path: '/st/bcra',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'BCRAStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Situacion BCRA',
          }                                  
        },
        {
          path: 'configuration',
          name: 'BCRAStaffConfiguration',
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA configuración',
          }                                  
        }, 
        {
          path: 'query',
          name: 'BCRAStaffQuery',
          component: ViewStaffQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA consulta',
          }                                  
        },  
        {
          path: 'query/:params',
          name: 'BCRAStaffQueryParams',
          component: ViewStaffQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA consulta',
          }                                  
        },                           
        {
          path: 'log',
          name: 'BCRAStaffLog',
          component: ViewStaffLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'BCRA log',
          }                                  
        },                          
      ]
    },

    {
      path: '/cu/bcra',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/bcra',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
